import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const OpenAccessPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Open Access Policy"
    description="MAH Quantum Research Institute is committed to ensuring that published research is openly accessible to the global academic and professional community."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }, { label: 'Open Access Policy', path: '/open-access' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Open Access Commitment</h2>
        <p className="text-[#4B5563] leading-relaxed mb-4">
          All publications on the MAH Quantum Research Institute platform are made openly accessible without subscription barriers. We believe that removing financial and institutional access barriers is essential for the equitable advancement of global research.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          Accepted publications are assigned DOIs and archived via Zenodo to ensure open access and long-term availability. This ensures that published work remains accessible indefinitely, independent of the platform's continued operation.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-5 pb-3 border-b border-[#E5E7EB]">Archiving & Preservation</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { title: 'Zenodo Archiving', desc: 'Published articles are deposited in Zenodo, CERN\'s open-access repository, providing long-term preservation and global discoverability.' },
            { title: 'DOI Assignment', desc: 'Every published article receives a permanent DOI, enabling persistent citation and ensuring the work is findable regardless of URL changes.' },
            { title: 'Google Scholar Indexing', desc: 'Zenodo-archived publications are indexed by Google Scholar, one of the most widely used academic search engines globally.' },
            { title: 'Metadata Availability', desc: 'Bibliographic metadata for all publications is made openly available to support harvesting by academic search systems and library databases.' },
          ].map(item => (
            <div key={item.title} className="border border-[#E5E7EB] p-5 bg-white">
              <h3 className="font-semibold text-[#1F1F1F] text-sm mb-2">{item.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Licensing</h2>
        <p className="text-[#4B5563] leading-relaxed">
          Published articles are made available under a <strong>Creative Commons Attribution (CC BY)</strong> or equivalent open licence, allowing readers to read, download, copy, distribute, and build upon the work, provided appropriate credit is given to the original authors and source. Specific licensing terms are indicated on each published article.
        </p>
      </section>
    </div>
  </StaticPageLayout>
);

export default OpenAccessPage;
